<template>
  <span>
    <span
      v-if="showIcon"
      :class="$style.iconStyle"
    >
      <Icon
        icon="premiumDiscover"
      />
    </span>
    <span
      data-test-id="PremiumFeatureIcon__label"
    >
      {{ iconLabel }}
    </span>
  </span>
</template>

<script>
import { Icon } from '@jumpcloud/ui-components';
import { mapGetters } from 'vuex';

export default {
  name: 'PremiumFeatureIcon',
  components: { Icon },
  props: {
    featureCode: {
      type: String,
      required: true,
      default: null,
    },
    iconLabel: {
      type: String,
      required: false,
      default: null,
    },
  },

  computed: {
    ...mapGetters('PlanModule', [
      'planHasFeature',
    ]),

    showIcon() {
      return !this.planHasFeature(this.featureCode);
    },
  },
};
</script>

<style module>
.iconStyle {
  background-color: var(--jcTertiary50);
  border: 1px solid var(--jcTertiary50);
  border-radius: 0.313rem;
  display: inline-block;
  font-size: 1rem;
  margin-right: 0.75rem;
  padding-top: 0.25rem;
  text-align: center;
  width: 1.5rem;
}
</style>
